/**
 * Pill-style status filter bar for master-data tables (Workers, Projects, Assignments).
 *
 * Usage:
 *   <StatusFilter
 *     value={statusFilter}
 *     onChange={setStatusFilter}
 *     counts={{ active: 3, completed: 12, all: 15 }}
 *     options={[
 *       { value: "active", label: "Active" },
 *       { value: "completed", label: "Completed" },
 *       { value: "all", label: "All" },
 *     ]}
 *   />
 *
 * Each button carries `data-testid="filter-{value}"` for automation.
 */
export function StatusFilter({ options, value, onChange, counts = {} }) {
  return (
    <div
      className="inline-flex items-center gap-1 p-1 bg-slate-100 border border-slate-200 rounded-md"
      data-testid="status-filter"
    >
      {options.map((opt) => {
        const active = value === opt.value;
        const count = counts?.[opt.value];
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            data-testid={`filter-${opt.value}`}
            className={`h-8 px-3 rounded text-xs font-semibold transition-colors ${
              active
                ? "bg-slate-900 text-white"
                : "text-slate-600 hover:bg-white hover:text-slate-900"
            }`}
          >
            {opt.label}
            {count != null && (
              <span
                className={`ml-1.5 text-[10px] ${active ? "text-slate-300" : "text-slate-400"}`}
              >
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
